import React from 'react';
import { classNames } from '../../utils/style';

export interface FeatureListProps {
  /** The list of features to display */
  children: React.ReactNode;
}

/**
 * FeatureList component that displays a vertical list of features
 * in a pricing card with consistent spacing.
 *
 * @example
 * ```tsx
 * <FeatureList>
 *   <Feature name="50 employees" />
 *   <Feature name="Basic support" />
 * </FeatureList>
 * ```
 */
export const FeatureList = ({ children }: FeatureListProps) => {
  return (
    <div
      className={classNames('FeatureList', 'flex flex-col gap-8 mt-24 mb-40')}
    >
      {children}
    </div>
  );
};
